import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import styled from '@mui/system/styled';
import { parseEmbeddedCSV } from '@/utils/embedded-csv';

interface ProductDetailCSVTableProps {
  description?: string
};

const StyledTableHead = styled(TableHead)({
  height: '38px',
  'th': {
    padding: '5px 8px',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '0',
    lineHeight: '16px',
    borderBottom: 'solid 1px #ddd',
  },
});

const StyledTableRow = styled(TableRow)({
  backgroundColor: '#f1f1f1',
  '&:nth-of-type(odd)': {
    backgroundColor: '#ffffff0d',
  },
  '.MuiTableCell-root': {
    border: '0',
  },
  '.MuiLink-root': {
    fontSize: '13px',
    letterSpacing: '0.1px',
    lineHeight: '16px',
    textDecoration: 'unset',
  },
  '.MuiTableCell-body': {
    padding: '5px 8px',
    color: '#000000',
    fontSize: '13px',
    letterSpacing: '0.1px',
    lineHeight: '16px',
    '.MuiButton-root': {
      padding: '0',
      justifyContent: 'flex-start',
      transition: 'unset',
      backgroundColor: 'transparent',
      'span': {
        display: 'none'
      }
    }
  }
});

const ProductDetailCSVTable: React.FC<ProductDetailCSVTableProps> = ({ description }) => {
  const parsedCSV = parseEmbeddedCSV(description);
  return (
    <>
      {!parsedCSV?.meta?.aborted &&
        <Box sx={{ paddingTop: { sm: 7, xs: 2 }, paddingBottom: { sm: 12, xs: 0 } }}>
          <Grid item xs={12}>
            <TableContainer>
              <Table>
                {parsedCSV?.meta?.fields &&
                  <StyledTableHead>
                    <TableRow>
                      {parsedCSV?.meta?.fields?.map((fieldName, index) => <TableCell key={index}>{
                        // rimuovo testo tra parentesti dalle intestazioni della tabella CSV
                        fieldName?.replaceAll(/\(.*\)/g, '')
                      }</TableCell>)}
                    </TableRow>
                  </StyledTableHead>
                }
                {parsedCSV?.data &&
                  <TableBody>
                    {parsedCSV?.data?.map((row:any, index) => {
                      return <StyledTableRow key={index}>
                        {parsedCSV?.meta?.fields &&
                          parsedCSV?.meta?.fields.map((fieldName, index) => <TableCell key={index}>
                            {row[fieldName]}
                          </TableCell>)
                        }
                        {!parsedCSV?.meta?.fields &&
                          row.map((cell: string, index: number) => <TableCell key={index}>
                            {cell}
                          </TableCell>)
                        }
                      </StyledTableRow>
                    })}
                  </TableBody>
                }
              </Table>
            </TableContainer>
          </Grid>
        </Box>
      }
    </>
  )
}

export default ProductDetailCSVTable;
